var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('Enterprise'),_c('Position'),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/files?imagePath=/banner/banner-middle.png","alt":""}}),_c('Personnel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }